import React from 'react';
import {View, Text, Platform, Linking} from 'react-native';

import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import {styles} from './styles';

// Apenas o conteúdo. O <Modal> é fornecido pelo AppModalHost
// para evitar concorrência de apresentação no iOS.
const UpdateModal = () => {
  const appStoreUrl =
    Platform.OS === 'ios'
      ? 'https://apps.apple.com/app/id6736531681'
      : 'https://play.google.com/store/apps/details?id=com.conecta.brasal';

  return (
    <View style={styles.containerModal}>
      <View style={styles.containerFilter}>
        <Text
          style={{
            fontSize: 20,
            lineHeight: 26,
            color: 'black',
            textAlign: 'center',
            maxWidth: 300,
            alignSelf: 'center',
            fontFamily: 'TCCC-UnityText Bold',
            marginTop: 20,
          }}>
          O seu aplicativo está desatualizado
        </Text>

        <View>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 18,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 300,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 30,
            }}>
            Seu aplicativo está
          </Text>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 18,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 300,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 10,
            }}>
            desatualizado
          </Text>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 18,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 200,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 10,
            }}>
            baixe a nova versão
          </Text>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 18,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 200,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 10,
            }}>
            na loja!
          </Text>
        </View>

        <View style={styles.containerButton}>
          <ButtonComponent
            title="Atualizar!"
            outlined
            width="80%"
            onPress={() => Linking.openURL(appStoreUrl)}
          />
        </View>
      </View>
    </View>
  );
};

export default UpdateModal;
